export var ImageModeValues = {
    CROP: 1 /* ImageMode.CROP */,
    FIT: 2 /* ImageMode.FIT */,
};
export var ImageRatioList = [
    {
        sdkId: 0,
        title: '3:2',
        ratio: { width: 3, height: 2 },
    },
    {
        sdkId: 1,
        title: '4:3',
        ratio: { width: 4, height: 3 },
    },
    {
        sdkId: 2,
        title: '1:1',
        ratio: { width: 1, height: 1 },
    },
    {
        sdkId: 3,
        title: '3:4',
        ratio: { width: 3, height: 4 },
    },
    {
        sdkId: 4,
        title: '2:3',
        ratio: { width: 2, height: 3 },
    },
];
//# sourceMappingURL=constants.js.map